import list from 'src/modules/notificacion/list/notificacionListReducers';
import form from 'src/modules/notificacion/form/notificacionFormReducers';
import view from 'src/modules/notificacion/view/notificacionViewReducers';
import destroy from 'src/modules/notificacion/destroy/notificacionDestroyReducers';
import importerReducer from 'src/modules/notificacion/importer/notificacionImporterReducers';
import { combineReducers } from 'redux';

export default combineReducers({
  list,
  form,
  view,
  destroy,
  importer: importerReducer,
});
